import { useState, useEffect, useMemo } from 'react';

export const useMarketingFiltering = (board) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");

  // Debounce search query to improve performance
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  // Filter items based on search query
  const { filteredLists, searchResultsCount } = useMemo(() => {
    if (!board || !board.lists) {
      return { filteredLists: {}, searchResultsCount: null };
    }

    let filtered = board.lists;
    let totalResults = 0;

    // Apply search filter if query exists
    if (debouncedSearchQuery && debouncedSearchQuery.trim() !== '') {
      const query = debouncedSearchQuery.toLowerCase().trim();
      
      // Filter function for search - matches actual Marketing card fields
      const filterBySearch = (item) => {
        // Search in main fields
        const searchFields = [
          item.id && item.id.toString(),
          item.title,
          item.description,
        ];
        
        // Also search in task titles if tasks exist
        if (item.tasks && Array.isArray(item.tasks)) {
          item.tasks.forEach(task => {
            if (task.title) {
              searchFields.push(task.title);
            }
          });
        }

        return searchFields.some(field => 
          field && field.toString().toLowerCase().includes(query)
        );
      };

      // Create filtered lists with filtered cards
      filtered = {};
      Object.keys(board.lists).forEach(listId => {
        const list = board.lists[listId];
        const filteredCards = (list.cards || []).filter(filterBySearch);
        totalResults += filteredCards.length;
        
        filtered[listId] = {
          ...list,
          cards: filteredCards
        };
      });
    } else {
      // If no search query, count all cards
      totalResults = null;
    }

    return { 
      filteredLists: filtered, 
      searchResultsCount: totalResults
    };
  }, [board, debouncedSearchQuery]);

  return {
    searchQuery,
    setSearchQuery,
    debouncedSearchQuery,
    filteredLists,
    searchResultsCount,
  };
};